 <template>
  <div style="height:100%">
    <!-- 搜素框 -->
    <!-- <el-form :inline="true" :model="params" style="padding-top:20px;padding-left:20px;margin-bottom:20px;background-color:#fff;border-radius:8px" size="small">
        <el-form-item label="区域编号">
          <el-input v-model="params.regionCode" placeholder="请输入区域编号"></el-input>
        </el-form-item>
        <el-form-item label="区域名">
          <el-input v-model="params.regionName" placeholder="请输入区域名"></el-input>
        </el-form-item>
      <el-form-item>
        <el-button @click="checkData" type="primary" size="mini">查询</el-button>
       <el-button type="info" @click="reset" size="mini">重置</el-button>
      </el-form-item>
    </el-form> -->
    <!-- 表格 -->
    <div style="padding: 20px;height: 800px">
      <div style="height:82%;background-color:#fff;border-radius:8px;padding-top: 8px;">
        <el-button type="primary" size="small" style="float:right;margin-top:20px;margin-right:20px;margin-bottom:20px" @click="add()" v-show="authorization('/home-admin/routineManage/region-manage/add')">新增</el-button>
        <el-table :data="tableData" stripe style="padding:0 20px;" height="80%" size="small" :header-cell-style="{'background-color':'#84aace4a','color':'#343333','text-align':'center'}" :cell-style="{'text-align':'center'}">
          <el-table-column prop="regionName" label="区域名"></el-table-column>
            <el-table-column prop="orderIndex" label="排序"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" :formatter="dateFormat"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip effect="dark" content="编辑" placement="top-end" v-show="authorization('/home-admin/routineManage/region-manage/edit')">
                <el-button type="primary" icon="el-icon-edit" circle size="mini" @click="edit(scope.row)" style="margin-right: 5px"></el-button>
              </el-tooltip>
              <el-tooltip effect="dark" content="删除" placement="top-end" v-show="authorization('/home-admin/routineManage/region-manage/del')">
                <el-popconfirm title="确认删除吗？" @confirm="deleteRegion(scope.row)">
                  <el-button content="删除" slot="reference" type="danger" icon="el-icon-delete" circle size="mini"></el-button>
                </el-popconfirm>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding-top:20px;height:40px;background-color:#fff;width: 100%;border-radius:8px;text-align:right">
          <el-pagination background :page-sizes="sizes" layout="total,sizes,prev,pager,next" :total="total" @current-change="handleCurrentChange" @size-change="sizeChange"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 弹出层 -->
    <el-dialog title="新增" :visible.sync="dialogFormAdd" width="700px" :close-on-click-modal="false">
      <el-form :model="regionManageArray" :rules="rules" ref="regionManageArray" label-width="160px" size="small" style="width:600px">
  <!--   <el-form-item label="区域编号" prop="regionCode">
            <el-input v-model="regionManageArray.regionCode" autocomplete="off"></el-input>
          </el-form-item>-->
          <el-form-item label="区域名" prop="regionName">
            <el-input v-model="regionManageArray.regionName"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="orderIndex">
            <el-input-number v-model="regionManageArray.orderIndex" :min="0"></el-input-number>
          </el-form-item>
        </el-form>
      <div slot="footer" style="margin-top:50px">
        <el-button @click="dialogFormAdd = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="addSubMit('regionManageArray')" size="mini">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑弹出层 -->
    <el-dialog title="编辑" :visible.sync="dialogFormEdit" width="700px" :close-on-click-modal="false">
      <el-form :model="regionManageArray" :rules="rules" ref="regionManageArray" label-width="160px" size="small" style="width:600px">
  <!--   <el-form-item label="区域编号" prop="regionCode">
            <el-input v-model="regionManageArray.regionCode" autocomplete="off"></el-input>
          </el-form-item>-->
          <el-form-item label="区域名" prop="regionName">
            <el-input v-model="regionManageArray.regionName"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="orderIndex">
            <el-input-number v-model="regionManageArray.orderIndex" :min="0"></el-input-number>
          </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top:50px">
        <el-button @click="dialogFormEdit = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="editSubMit('regionManageArray')" size="mini">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { authorization } from '../../../authorization/authorization'
export default {
  data() {
    return {
      dialogFormAdd: false,
      dialogFormEdit: false,
      tableData: [],
      params: {
        regionCode: "",
        regionName: "",
        page: 1,
        size: 10,
      },
      regionManageArray: {
        id:"",
        regionCode: "",
        regionName: "",
        orderIndex:1
      },
      rules: {
        /*regionCode:[
          { required: true, message: '请输入区域编号', trigger: 'blur' },
        ],*/
        regionName:[
          { required: true, message: '请输入区域名', trigger: 'blur' },
        ],
         orderIndex:[
          { required: true, message: '请输入排序编码', trigger: 'blur' },
        ],
      },
      total: 0,
      sizes: [10, 15],
    };
  },
  created() {
    this.queryRegionManageList();
  },
  methods: {
    authorization,
    queryRegionManageList(){//获取区域列表
      this.axios({
        method: "get",
        url: "/v1/web/region-manage/select-region-list",
        params: this.params,
      }).then((res) => {
        this.tableData = res.data.data.list;
        this.total = res.data.data.total;
      });
    },
    add(){//新增弹出层
      this.dialogFormAdd = true;
      this.regionManageArray = {};
    },
    addSubMit(formName){//新增提交
      this.$refs[formName].validate((valid) => {
        if (!valid) {
            return false
        }else {
          this.axios({
            method: "post",
            url: "/v1/web/region-manage/add-region",
            data: this.regionManageArray,
          }).then((res) => {
            if (res.data.code === 200) {
              console.log(res);
              this.dialogFormAdd = false;
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.queryRegionManageList();
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      })
    },
    edit(row){//编辑弹出层
      this.dialogFormEdit = true;
      this.regionManageArray = row;
    },
    editSubMit(formName){//编辑提交
      this.$refs[formName].validate((valid) => {
        if (!valid) {
            return false
        }else {
          this.axios({
            method: "post",
            url: "/v1/web/region-manage/update-region/" + this.regionManageArray.id,
            data: this.regionManageArray,
          }).then((res) => {
            if (res.data.code === 200) {
              this.dialogFormEdit = false;
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.queryRegionManageList();
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      })
    },
    deleteRegion(row){//删除提交
      this.axios({
        method: "delete",
        url: "/v1/web/region-manage/delete-region/" + row.id,
      }).then((res) => {
        if (res.data.code === 200) {
          this.queryRegionManageList();
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },
    dateFormat:function(row){
      if(row.createTime !== null && row.createTime !== undefined){
        return moment(row.createTime).format("YYYY-MM-DD HH:mm:ss")
      }
    },
    handleCurrentChange(val) {
      this.params.page = val;
      this.queryRegionManageList();
    },
    sizeChange(val) {
      this.params.size = val;
      this.params.page = 1;
      this.queryRegionManageList();
    },
    checkData() {
      this.queryRegionManageList();
    },
    reset() {
      this.params = { page: 1, size: 10 };
      this.queryRegionManageList();
    },
  },
};
</script>

<style scoped>
</style>
